var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeUpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 1.65527H2.48275V2.48286H1.65517V1.65527Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 1.65527H3.31034V2.48286H2.48275V1.65527Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 1.65527H4.13793V2.48286H3.31034V1.65527Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 1.65527H4.96551V2.48286H4.13793V1.65527Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 1.65527H5.7931V2.48286H4.96551V1.65527Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 1.65527H6.62068V2.48286H5.7931V1.65527Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 1.65527H7.44827V2.48286H6.62068V1.65527Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 1.65527H12.4138V2.48286H11.5862V1.65527Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 1.65527H14.069V2.48286H13.2414V1.65527Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 1.65527H15.7241V2.48286H14.8965V1.65527Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 1.65527H17.3793V2.48286H16.5517V1.65527Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 1.65527H18.2069V2.48286H17.3793V1.65527Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 1.65527H19.0345V2.48286H18.2069V1.65527Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 1.65527H19.8621V2.48286H19.0345V1.65527Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 1.65527H20.6896V2.48286H19.8621V1.65527Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 1.65527H21.5172V2.48286H20.6896V1.65527Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 1.65527H22.3448V2.48286H21.5172V1.65527Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 2.48286H2.48275V3.31045H1.65517V2.48286Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 2.48286H7.44827V3.31045H6.62068V2.48286Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 2.48286H9.93103V3.31045H9.10344V2.48286Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 2.48286H10.7586V3.31045H9.93103V2.48286Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 2.48286H12.4138V3.31045H11.5862V2.48286Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 2.48286H13.2414V3.31045H12.4138V2.48286Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 2.48286H17.3793V3.31045H16.5517V2.48286Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 2.48286H22.3448V3.31045H21.5172V2.48286Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 3.31045H2.48275V4.13803H1.65517V3.31045Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 3.31045H4.13793V4.13803H3.31034V3.31045Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 3.31045H4.96551V4.13803H4.13793V3.31045Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 3.31045H5.7931V4.13803H4.96551V3.31045Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 3.31045H7.44827V4.13803H6.62068V3.31045Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 3.31045H9.10344V4.13803H8.27586V3.31045Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 3.31045H12.4138V4.13803H11.5862V3.31045Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 3.31045H14.069V4.13803H13.2414V3.31045Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 3.31045H17.3793V4.13803H16.5517V3.31045Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 3.31045H19.0345V4.13803H18.2069V3.31045Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 3.31045H19.8621V4.13803H19.0345V3.31045Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 3.31045H20.6896V4.13803H19.8621V3.31045Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 3.31045H22.3448V4.13803H21.5172V3.31045Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 4.13803H2.48275V4.96562H1.65517V4.13803Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 4.13803H4.13793V4.96562H3.31034V4.13803Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 4.13803H4.96551V4.96562H4.13793V4.13803Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 4.13803H5.7931V4.96562H4.96551V4.13803Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 4.13803H7.44827V4.96562H6.62068V4.13803Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 4.13803H9.10344V4.96562H8.27586V4.13803Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 4.13803H9.93103V4.96562H9.10344V4.13803Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 4.13803H10.7586V4.96562H9.93103V4.13803Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 4.13803H12.4138V4.96562H11.5862V4.13803Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 4.13803H13.2414V4.96562H12.4138V4.13803Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 4.13803H14.069V4.96562H13.2414V4.13803Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 4.13803H14.8965V4.96562H14.069V4.13803Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 4.13803H15.7241V4.96562H14.8965V4.13803Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 4.13803H17.3793V4.96562H16.5517V4.13803Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 4.13803H19.0345V4.96562H18.2069V4.13803Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 4.13803H19.8621V4.96562H19.0345V4.13803Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 4.13803H20.6896V4.96562H19.8621V4.13803Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 4.13803H22.3448V4.96562H21.5172V4.13803Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 4.96562H2.48275V5.7932H1.65517V4.96562Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 4.96562H4.13793V5.7932H3.31034V4.96562Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 4.96562H4.96551V5.7932H4.13793V4.96562Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 4.96562H5.7931V5.7932H4.96551V4.96562Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 4.96562H7.44827V5.7932H6.62068V4.96562Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 4.96562H9.93103V5.7932H9.10344V4.96562Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 4.96562H10.7586V5.7932H9.93103V4.96562Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 4.96562H14.069V5.7932H13.2414V4.96562Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 4.96562H17.3793V5.7932H16.5517V4.96562Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 4.96562H19.0345V5.7932H18.2069V4.96562Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 4.96562H19.8621V5.7932H19.0345V4.96562Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 4.96562H20.6896V5.7932H19.8621V4.96562Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 4.96562H22.3448V5.7932H21.5172V4.96562Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 5.7932H2.48275V6.62079H1.65517V5.7932Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 5.7932H7.44827V6.62079H6.62068V5.7932Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 5.7932H13.2414V6.62079H12.4138V5.7932Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 5.7932H14.069V6.62079H13.2414V5.7932Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 5.7932H14.8965V6.62079H14.069V5.7932Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 5.7932H15.7241V6.62079H14.8965V5.7932Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 5.7932H17.3793V6.62079H16.5517V5.7932Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 5.7932H22.3448V6.62079H21.5172V5.7932Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 6.62079H2.48275V7.44838H1.65517V6.62079Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 6.62079H3.31034V7.44838H2.48275V6.62079Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 6.62079H4.13793V7.44838H3.31034V6.62079Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 6.62079H4.96551V7.44838H4.13793V6.62079Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 6.62079H5.7931V7.44838H4.96551V6.62079Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 6.62079H6.62068V7.44838H5.7931V6.62079Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 6.62079H7.44827V7.44838H6.62068V6.62079Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 6.62079H9.10344V7.44838H8.27586V6.62079Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 6.62079H10.7586V7.44838H9.93103V6.62079Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 6.62079H12.4138V7.44838H11.5862V6.62079Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 6.62079H14.069V7.44838H13.2414V6.62079Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 6.62079H15.7241V7.44838H14.8965V6.62079Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 6.62079H17.3793V7.44838H16.5517V6.62079Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 6.62079H18.2069V7.44838H17.3793V6.62079Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 6.62079H19.0345V7.44838H18.2069V6.62079Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 6.62079H19.8621V7.44838H19.0345V6.62079Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 6.62079H20.6896V7.44838H19.8621V6.62079Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 6.62079H21.5172V7.44838H20.6896V6.62079Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 6.62079H22.3448V7.44838H21.5172V6.62079Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 7.44838H9.93103V8.27596H9.10344V7.44838Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 7.44838H10.7586V8.27596H9.93103V7.44838Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 7.44838H11.5862V8.27596H10.7586V7.44838Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 7.44838H12.4138V8.27596H11.5862V7.44838Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 7.44838H15.7241V8.27596H14.8965V7.44838Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 8.27596H4.96551V9.10355H4.13793V8.27596Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 8.27596H5.7931V9.10355H4.96551V8.27596Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 8.27596H7.44827V9.10355H6.62068V8.27596Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 8.27596H8.27586V9.10355H7.44827V8.27596Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 8.27596H11.5862V9.10355H10.7586V8.27596Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 8.27596H12.4138V9.10355H11.5862V8.27596Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 8.27596H13.2414V9.10355H12.4138V8.27596Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 8.27596H15.7241V9.10355H14.8965V8.27596Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 8.27596H19.8621V9.10355H19.0345V8.27596Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 8.27596H20.6896V9.10355H19.8621V8.27596Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 9.10355H2.48275V9.93114H1.65517V9.10355Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 9.10355H4.13793V9.93114H3.31034V9.10355Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 9.10355H4.96551V9.93114H4.13793V9.10355Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 9.10355H5.7931V9.93114H4.96551V9.10355Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 9.10355H6.62068V9.93114H5.7931V9.10355Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 9.10355H8.27586V9.93114H7.44827V9.10355Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 9.10355H9.10344V9.93114H8.27586V9.10355Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 9.10355H9.93103V9.93114H9.10344V9.10355Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 9.10355H10.7586V9.93114H9.93103V9.10355Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 9.10355H11.5862V9.93114H10.7586V9.10355Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 9.10355H12.4138V9.93114H11.5862V9.10355Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 9.10355H13.2414V9.93114H12.4138V9.10355Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 9.10355H14.069V9.93114H13.2414V9.10355Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 9.10355H14.8965V9.93114H14.069V9.10355Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 9.10355H18.2069V9.93114H17.3793V9.10355Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 9.10355H19.0345V9.93114H18.2069V9.10355Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 9.10355H20.6896V9.93114H19.8621V9.10355Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 9.93114H3.31034V10.7587H2.48275V9.93114Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 9.93114H7.44827V10.7587H6.62068V9.93114Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 9.93114H8.27586V10.7587H7.44827V9.93114Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 9.93114H9.10344V10.7587H8.27586V9.93114Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 9.93114H9.93103V10.7587H9.10344V9.93114Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 9.93114H11.5862V10.7587H10.7586V9.93114Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 9.93114H15.7241V10.7587H14.8965V9.93114Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 9.93114H18.2069V10.7587H17.3793V9.93114Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 9.93114H19.0345V10.7587H18.2069V9.93114Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 9.93114H22.3448V10.7587H21.5172V9.93114Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 10.7587H3.31034V11.5863H2.48275V10.7587Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 10.7587H5.7931V11.5863H4.96551V10.7587Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 10.7587H6.62068V11.5863H5.7931V10.7587Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 10.7587H10.7586V11.5863H9.93103V10.7587Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 10.7587H11.5862V11.5863H10.7586V10.7587Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 10.7587H19.0345V11.5863H18.2069V10.7587Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 10.7587H19.8621V11.5863H19.0345V10.7587Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 10.7587H20.6896V11.5863H19.8621V10.7587Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 10.7587H21.5172V11.5863H20.6896V10.7587Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 11.5863H5.7931V12.4139H4.96551V11.5863Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 11.5863H7.44827V12.4139H6.62068V11.5863Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 11.5863H10.7586V12.4139H9.93103V11.5863Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 11.5863H11.5862V12.4139H10.7586V11.5863Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 11.5863H14.8965V12.4139H14.069V11.5863Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.5863H16.5517V12.4139H15.7241V11.5863Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 11.5863H17.3793V12.4139H16.5517V11.5863Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 11.5863H18.2069V12.4139H17.3793V11.5863Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 11.5863H21.5172V12.4139H20.6896V11.5863Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 11.5863H22.3448V12.4139H21.5172V11.5863Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 12.4139H2.48275V13.2415H1.65517V12.4139Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 12.4139H3.31034V13.2415H2.48275V12.4139Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 12.4139H8.27586V13.2415H7.44827V12.4139Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 12.4139H9.10344V13.2415H8.27586V12.4139Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 12.4139H11.5862V13.2415H10.7586V12.4139Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 12.4139H17.3793V13.2415H16.5517V12.4139Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 12.4139H19.0345V13.2415H18.2069V12.4139Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 12.4139H21.5172V13.2415H20.6896V12.4139Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 13.2415H2.48275V14.0691H1.65517V13.2415Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 13.2415H3.31034V14.0691H2.48275V13.2415Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 13.2415H4.13793V14.0691H3.31034V13.2415Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 13.2415H6.62068V14.0691H5.7931V13.2415Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 13.2415H7.44827V14.0691H6.62068V13.2415Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 13.2415H8.27586V14.0691H7.44827V13.2415Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 13.2415H9.93103V14.0691H9.10344V13.2415Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 13.2415H10.7586V14.0691H9.93103V13.2415Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 13.2415H11.5862V14.0691H10.7586V13.2415Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 13.2415H14.069V14.0691H13.2414V13.2415Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 13.2415H14.8965V14.0691H14.069V13.2415Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.2415H16.5517V14.0691H15.7241V13.2415Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 13.2415H18.2069V14.0691H17.3793V13.2415Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 13.2415H19.0345V14.0691H18.2069V13.2415Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 13.2415H21.5172V14.0691H20.6896V13.2415Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 13.2415H22.3448V14.0691H21.5172V13.2415Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 14.0691H2.48275V14.8967H1.65517V14.0691Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 14.0691H4.13793V14.8967H3.31034V14.0691Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 14.0691H4.96551V14.8967H4.13793V14.0691Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 14.0691H6.62068V14.8967H5.7931V14.0691Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 14.0691H9.93103V14.8967H9.10344V14.0691Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 14.0691H10.7586V14.8967H9.93103V14.0691Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 14.0691H11.5862V14.8967H10.7586V14.0691Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 14.0691H14.069V14.8967H13.2414V14.0691Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 14.0691H15.7241V14.8967H14.8965V14.0691Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 14.0691H18.2069V14.8967H17.3793V14.0691Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 14.0691H19.8621V14.8967H19.0345V14.0691Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 14.0691H20.6896V14.8967H19.8621V14.0691Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 14.0691H22.3448V14.8967H21.5172V14.0691Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 14.8967H2.48275V15.7242H1.65517V14.8967Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 14.8967H4.13793V15.7242H3.31034V14.8967Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 14.8967H4.96551V15.7242H4.13793V14.8967Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 14.8967H5.7931V15.7242H4.96551V14.8967Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 14.8967H7.44827V15.7242H6.62068V14.8967Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44827 14.8967H8.27586V15.7242H7.44827V14.8967Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 14.8967H9.93103V15.7242H9.10344V14.8967Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 14.8967H11.5862V15.7242H10.7586V14.8967Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 14.8967H14.069V15.7242H13.2414V14.8967Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 14.8967H14.8965V15.7242H14.069V14.8967Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 14.8967H15.7241V15.7242H14.8965V14.8967Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.8967H16.5517V15.7242H15.7241V14.8967Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 14.8967H17.3793V15.7242H16.5517V14.8967Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 14.8967H18.2069V15.7242H17.3793V14.8967Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 14.8967H19.0345V15.7242H18.2069V14.8967Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 14.8967H19.8621V15.7242H19.0345V14.8967Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 14.8967H20.6896V15.7242H19.8621V14.8967Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 14.8967H22.3448V15.7242H21.5172V14.8967Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 15.7242H9.10344V16.5518H8.27586V15.7242Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 15.7242H9.93103V16.5518H9.10344V15.7242Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 15.7242H11.5862V16.5518H10.7586V15.7242Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 15.7242H12.4138V16.5518H11.5862V15.7242Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 15.7242H15.7241V16.5518H14.8965V15.7242Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 15.7242H19.0345V16.5518H18.2069V15.7242Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 16.5518H2.48275V17.3794H1.65517V16.5518Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 16.5518H3.31034V17.3794H2.48275V16.5518Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 16.5518H4.13793V17.3794H3.31034V16.5518Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 16.5518H4.96551V17.3794H4.13793V16.5518Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 16.5518H5.7931V17.3794H4.96551V16.5518Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 16.5518H6.62068V17.3794H5.7931V16.5518Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 16.5518H7.44827V17.3794H6.62068V16.5518Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 16.5518H9.10344V17.3794H8.27586V16.5518Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7586 16.5518H11.5862V17.3794H10.7586V16.5518Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 16.5518H13.2414V17.3794H12.4138V16.5518Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 16.5518H14.069V17.3794H13.2414V16.5518Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 16.5518H14.8965V17.3794H14.069V16.5518Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 16.5518H15.7241V17.3794H14.8965V16.5518Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 16.5518H17.3793V17.3794H16.5517V16.5518Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 16.5518H19.0345V17.3794H18.2069V16.5518Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 16.5518H19.8621V17.3794H19.0345V16.5518Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 16.5518H20.6896V17.3794H19.8621V16.5518Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 16.5518H22.3448V17.3794H21.5172V16.5518Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 17.3794H2.48275V18.207H1.65517V17.3794Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 17.3794H7.44827V18.207H6.62068V17.3794Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 17.3794H9.93103V18.207H9.10344V17.3794Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 17.3794H12.4138V18.207H11.5862V17.3794Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 17.3794H13.2414V18.207H12.4138V17.3794Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 17.3794H14.8965V18.207H14.069V17.3794Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 17.3794H15.7241V18.207H14.8965V17.3794Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 17.3794H19.0345V18.207H18.2069V17.3794Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 17.3794H19.8621V18.207H19.0345V17.3794Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 18.207H2.48275V19.0346H1.65517V18.207Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 18.207H4.13793V19.0346H3.31034V18.207Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 18.207H4.96551V19.0346H4.13793V18.207Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 18.207H5.7931V19.0346H4.96551V18.207Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 18.207H7.44827V19.0346H6.62068V18.207Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 18.207H9.10344V19.0346H8.27586V18.207Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 18.207H14.069V19.0346H13.2414V18.207Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 18.207H15.7241V19.0346H14.8965V18.207Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.207H16.5517V19.0346H15.7241V18.207Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 18.207H17.3793V19.0346H16.5517V18.207Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 18.207H18.2069V19.0346H17.3793V18.207Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 18.207H19.0345V19.0346H18.2069V18.207Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 18.207H19.8621V19.0346H19.0345V18.207Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 19.0346H2.48275V19.8622H1.65517V19.0346Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 19.0346H4.13793V19.8622H3.31034V19.0346Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 19.0346H4.96551V19.8622H4.13793V19.0346Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 19.0346H5.7931V19.8622H4.96551V19.0346Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 19.0346H7.44827V19.8622H6.62068V19.0346Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 19.0346H9.10344V19.8622H8.27586V19.0346Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 19.0346H9.93103V19.8622H9.10344V19.0346Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 19.0346H10.7586V19.8622H9.93103V19.0346Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.0346H16.5517V19.8622H15.7241V19.0346Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 19.0346H22.3448V19.8622H21.5172V19.0346Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 19.8622H2.48275V20.6898H1.65517V19.8622Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 19.8622H4.13793V20.6898H3.31034V19.8622Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 19.8622H4.96551V20.6898H4.13793V19.8622Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 19.8622H5.7931V20.6898H4.96551V19.8622Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 19.8622H7.44827V20.6898H6.62068V19.8622Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93103 19.8622H10.7586V20.6898H9.93103V19.8622Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5862 19.8622H12.4138V20.6898H11.5862V19.8622Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 19.8622H14.069V20.6898H13.2414V19.8622Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 19.8622H15.7241V20.6898H14.8965V19.8622Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.8622H16.5517V20.6898H15.7241V19.8622Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 19.8622H17.3793V20.6898H16.5517V19.8622Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 19.8622H19.0345V20.6898H18.2069V19.8622Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 19.8622H21.5172V20.6898H20.6896V19.8622Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 19.8622H22.3448V20.6898H21.5172V19.8622Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 20.6898H2.48275V21.5173H1.65517V20.6898Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 20.6898H7.44827V21.5173H6.62068V20.6898Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 20.6898H14.069V21.5173H13.2414V20.6898Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 20.6898H14.8965V21.5173H14.069V20.6898Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 20.6898H15.7241V21.5173H14.8965V20.6898Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.6898H16.5517V21.5173H15.7241V20.6898Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 20.6898H17.3793V21.5173H16.5517V20.6898Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 20.6898H18.2069V21.5173H17.3793V20.6898Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 20.6898H19.8621V21.5173H19.0345V20.6898Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8621 20.6898H20.6896V21.5173H19.8621V20.6898Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6896 20.6898H21.5172V21.5173H20.6896V20.6898Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 20.6898H22.3448V21.5173H21.5172V20.6898Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 21.5173H2.48275V22.3449H1.65517V21.5173Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 21.5173H3.31034V22.3449H2.48275V21.5173Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 21.5173H4.13793V22.3449H3.31034V21.5173Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13793 21.5173H4.96551V22.3449H4.13793V21.5173Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96551 21.5173H5.7931V22.3449H4.96551V21.5173Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7931 21.5173H6.62068V22.3449H5.7931V21.5173Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62068 21.5173H7.44827V22.3449H6.62068V21.5173Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10344 21.5173H9.93103V22.3449H9.10344V21.5173Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 21.5173H13.2414V22.3449H12.4138V21.5173Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2414 21.5173H14.069V22.3449H13.2414V21.5173Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 21.5173H14.8965V22.3449H14.069V21.5173Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 21.5173H15.7241V22.3449H14.8965V21.5173Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5517 21.5173H17.3793V22.3449H16.5517V21.5173Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 21.5173H19.0345V22.3449H18.2069V21.5173Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0345 21.5173H19.8621V22.3449H19.0345V21.5173Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5172 21.5173H22.3448V22.3449H21.5172V21.5173Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48275 1.65527H1.65517V2.48286M2.48275 1.65527V2.48286M2.48275 1.65527H3.31034M2.48275 2.48286H1.65517M2.48275 2.48286H3.31034M2.48275 2.48286V3.31045M1.65517 2.48286V3.31045M3.31034 1.65527V2.48286M3.31034 1.65527H4.13793M3.31034 2.48286H4.13793M4.13793 1.65527V2.48286M4.13793 1.65527H4.96551M4.13793 2.48286H4.96551M4.96551 1.65527V2.48286M4.96551 1.65527H5.7931M4.96551 2.48286H5.7931M5.7931 1.65527V2.48286M5.7931 1.65527H6.62068M5.7931 2.48286H6.62068M6.62068 1.65527V2.48286M6.62068 1.65527H7.44827V2.48286M6.62068 2.48286H7.44827M6.62068 2.48286V3.31045M7.44827 2.48286V3.31045M12.4138 2.48286V1.65527H11.5862V2.48286M12.4138 2.48286H11.5862M12.4138 2.48286V3.31045M12.4138 2.48286H13.2414M11.5862 2.48286V3.31045M13.2414 2.48286H14.069V1.65527H13.2414V2.48286ZM13.2414 2.48286V3.31045M17.3793 1.65527H16.5517V2.48286M17.3793 1.65527V2.48286M17.3793 1.65527H18.2069M17.3793 2.48286H16.5517M17.3793 2.48286H18.2069M17.3793 2.48286V3.31045M16.5517 2.48286V3.31045M18.2069 1.65527V2.48286M18.2069 1.65527H19.0345M18.2069 2.48286H19.0345M19.0345 1.65527V2.48286M19.0345 1.65527H19.8621M19.0345 2.48286H19.8621M19.8621 1.65527V2.48286M19.8621 1.65527H20.6896M19.8621 2.48286H20.6896M20.6896 1.65527V2.48286M20.6896 1.65527H21.5172M20.6896 2.48286H21.5172M21.5172 1.65527V2.48286M21.5172 1.65527H22.3448V2.48286M21.5172 2.48286H22.3448M21.5172 2.48286V3.31045M22.3448 2.48286V3.31045M2.48275 3.31045H1.65517M2.48275 3.31045V4.13803M1.65517 3.31045V4.13803M7.44827 3.31045H6.62068M7.44827 3.31045V4.13803M6.62068 3.31045V4.13803M9.93103 2.48286H9.10344V3.31045M9.93103 2.48286V3.31045M9.93103 2.48286H10.7586V3.31045H9.93103M9.93103 3.31045H9.10344M9.10344 3.31045H8.27586V4.13803M9.10344 3.31045V4.13803M12.4138 3.31045H11.5862M12.4138 3.31045H13.2414M12.4138 3.31045V4.13803M11.5862 3.31045V4.13803M13.2414 3.31045H14.069V4.13803M13.2414 3.31045V4.13803M17.3793 3.31045H16.5517M17.3793 3.31045V4.13803M16.5517 3.31045V4.13803M22.3448 3.31045H21.5172M22.3448 3.31045V4.13803M21.5172 3.31045V4.13803M2.48275 4.13803H1.65517M2.48275 4.13803V4.96562M1.65517 4.13803V4.96562M4.13793 3.31045H3.31034V4.13803M4.13793 3.31045V4.13803M4.13793 3.31045H4.96551M4.13793 4.13803H3.31034M4.13793 4.13803H4.96551M4.13793 4.13803V4.96562M3.31034 4.13803V4.96562M4.96551 3.31045V4.13803M4.96551 3.31045H5.7931V4.13803M4.96551 4.13803H5.7931M4.96551 4.13803V4.96562M5.7931 4.13803V4.96562M7.44827 4.13803H6.62068M7.44827 4.13803V4.96562M6.62068 4.13803V4.96562M9.10344 4.13803H8.27586M9.10344 4.13803V4.96562M9.10344 4.13803H9.93103M8.27586 4.13803V4.96562H9.10344M12.4138 4.13803H11.5862M12.4138 4.13803V4.96562M12.4138 4.13803H13.2414M11.5862 4.13803V4.96562H12.4138M14.069 4.13803H13.2414M14.069 4.13803V4.96562M14.069 4.13803H14.8965M13.2414 4.13803V4.96562M17.3793 4.13803H16.5517M17.3793 4.13803V4.96562M16.5517 4.13803V4.96562M19.0345 3.31045H18.2069V4.13803M19.0345 3.31045V4.13803M19.0345 3.31045H19.8621M19.0345 4.13803H18.2069M19.0345 4.13803H19.8621M19.0345 4.13803V4.96562M18.2069 4.13803V4.96562M19.8621 3.31045V4.13803M19.8621 3.31045H20.6896V4.13803M19.8621 4.13803H20.6896M19.8621 4.13803V4.96562M20.6896 4.13803V4.96562M22.3448 4.13803H21.5172M22.3448 4.13803V4.96562M21.5172 4.13803V4.96562M2.48275 4.96562H1.65517M2.48275 4.96562V5.7932M1.65517 4.96562V5.7932M4.13793 4.96562H3.31034M4.13793 4.96562H4.96551M4.13793 4.96562V5.7932M3.31034 4.96562V5.7932H4.13793M4.96551 4.96562H5.7931M4.96551 4.96562V5.7932M5.7931 4.96562V5.7932H4.96551M7.44827 4.96562H6.62068M7.44827 4.96562V5.7932M6.62068 4.96562V5.7932M9.10344 4.96562H9.93103M9.10344 4.96562V5.7932H9.93103M9.93103 4.13803V4.96562M9.93103 4.13803H10.7586V4.96562M9.93103 4.96562H10.7586M9.93103 4.96562V5.7932M10.7586 4.96562V5.7932H9.93103M12.4138 4.96562H13.2414M13.2414 4.96562H14.069M13.2414 4.96562V5.7932M14.069 4.96562H14.8965M14.069 4.96562V5.7932M14.8965 4.13803V4.96562M14.8965 4.13803H15.7241V4.96562H14.8965M17.3793 4.96562H16.5517M17.3793 4.96562V5.7932M16.5517 4.96562V5.7932M19.0345 4.96562H18.2069M19.0345 4.96562H19.8621M19.0345 4.96562V5.7932M18.2069 4.96562V5.7932H19.0345M19.8621 4.96562H20.6896M19.8621 4.96562V5.7932M20.6896 4.96562V5.7932H19.8621M22.3448 4.96562H21.5172M22.3448 4.96562V5.7932M21.5172 4.96562V5.7932M2.48275 5.7932H1.65517M2.48275 5.7932V6.62079M1.65517 5.7932V6.62079M4.13793 5.7932H4.96551M7.44827 5.7932H6.62068M7.44827 5.7932V6.62079M6.62068 5.7932V6.62079M14.069 5.7932H13.2414M14.069 5.7932V6.62079M14.069 5.7932H14.8965M13.2414 5.7932H12.4138V6.62079M13.2414 5.7932V6.62079M17.3793 5.7932H16.5517M17.3793 5.7932V6.62079M16.5517 5.7932V6.62079M19.0345 5.7932H19.8621M22.3448 5.7932H21.5172M22.3448 5.7932V6.62079M21.5172 5.7932V6.62079M2.48275 6.62079H1.65517M2.48275 6.62079V7.44838M2.48275 6.62079H3.31034M1.65517 6.62079V7.44838H2.48275M7.44827 6.62079H6.62068M7.44827 6.62079V7.44838H6.62068M6.62068 6.62079H5.7931M6.62068 6.62079V7.44838M13.2414 6.62079H12.4138M13.2414 6.62079H14.069M13.2414 6.62079V7.44838H14.069V6.62079M12.4138 6.62079H11.5862V7.44838M12.4138 6.62079V7.44838M14.069 6.62079H14.8965M14.8965 5.7932V6.62079M14.8965 5.7932H15.7241V6.62079M14.8965 6.62079H15.7241M14.8965 6.62079V7.44838M15.7241 6.62079V7.44838M17.3793 6.62079H16.5517M17.3793 6.62079V7.44838M17.3793 6.62079H18.2069M16.5517 6.62079V7.44838H17.3793M22.3448 6.62079H21.5172M22.3448 6.62079V7.44838H21.5172M21.5172 6.62079H20.6896M21.5172 6.62079V7.44838M2.48275 7.44838H3.31034M3.31034 6.62079V7.44838M3.31034 6.62079H4.13793M3.31034 7.44838H4.13793M4.13793 6.62079V7.44838M4.13793 6.62079H4.96551M4.13793 7.44838H4.96551M4.96551 6.62079V7.44838M4.96551 6.62079H5.7931M4.96551 7.44838H5.7931M5.7931 6.62079V7.44838M5.7931 7.44838H6.62068M9.10344 7.44838V6.62079H8.27586V7.44838H9.10344ZM9.10344 7.44838H9.93103M9.10344 7.44838V8.27596H9.93103M10.7586 7.44838V6.62079H9.93103V7.44838M10.7586 7.44838H9.93103M10.7586 7.44838V8.27596M10.7586 7.44838H11.5862M9.93103 7.44838V8.27596M12.4138 7.44838H11.5862M12.4138 7.44838V8.27596M11.5862 7.44838V8.27596M15.7241 7.44838H14.8965M15.7241 7.44838V8.27596M14.8965 7.44838V8.27596M17.3793 7.44838H18.2069M18.2069 6.62079V7.44838M18.2069 6.62079H19.0345M18.2069 7.44838H19.0345M19.0345 6.62079V7.44838M19.0345 6.62079H19.8621M19.0345 7.44838H19.8621M19.8621 6.62079V7.44838M19.8621 6.62079H20.6896M19.8621 7.44838H20.6896M20.6896 6.62079V7.44838M20.6896 7.44838H21.5172M9.93103 8.27596H10.7586M10.7586 8.27596H11.5862M10.7586 8.27596V9.10355M11.5862 8.27596H12.4138M11.5862 8.27596V9.10355M12.4138 8.27596V9.10355M12.4138 8.27596H13.2414V9.10355M15.7241 8.27596H14.8965M15.7241 8.27596V9.10355H14.8965M14.8965 8.27596V9.10355M4.96551 8.27596H4.13793V9.10355M4.96551 8.27596V9.10355M4.96551 8.27596H5.7931V9.10355M4.96551 9.10355H4.13793M4.96551 9.10355H5.7931M4.96551 9.10355V9.93114M4.13793 9.10355H3.31034V9.93114M4.13793 9.10355V9.93114M5.7931 9.10355V9.93114M5.7931 9.10355H6.62068M7.44827 8.27596H6.62068V9.10355M7.44827 8.27596V9.10355M7.44827 8.27596H8.27586V9.10355M7.44827 9.10355H6.62068M7.44827 9.10355H8.27586M7.44827 9.10355V9.93114M6.62068 9.10355V9.93114M8.27586 9.10355V9.93114M8.27586 9.10355H9.10344M11.5862 9.10355H10.7586M11.5862 9.10355H12.4138M11.5862 9.10355V9.93114M10.7586 9.10355H9.93103M10.7586 9.10355V9.93114M12.4138 9.10355H13.2414M12.4138 9.10355V9.93114M13.2414 9.10355V9.93114M13.2414 9.10355H14.069M14.8965 9.10355H14.069M14.8965 9.10355V9.93114M19.8621 8.27596H19.0345V9.10355M19.8621 8.27596V9.10355M19.8621 8.27596H20.6896V9.10355M19.8621 9.10355H19.0345M19.8621 9.10355H20.6896M19.8621 9.10355V9.93114H20.6896V9.10355M19.0345 9.10355H18.2069M19.0345 9.10355V9.93114M2.48275 9.93114V9.10355H1.65517V9.93114H2.48275ZM2.48275 9.93114H3.31034M2.48275 9.93114V10.7587M4.13793 9.93114H3.31034M4.13793 9.93114H4.96551M3.31034 9.93114V10.7587M4.96551 9.93114H5.7931M5.7931 9.93114H6.62068M6.62068 9.93114H7.44827M6.62068 9.93114V10.7587M8.27586 9.93114H7.44827M8.27586 9.93114H9.10344M8.27586 9.93114V10.7587M7.44827 9.93114V10.7587M9.10344 9.10355V9.93114M9.10344 9.10355H9.93103M9.10344 9.93114H9.93103M9.10344 9.93114V10.7587M9.93103 9.10355V9.93114M9.93103 9.93114H10.7586M9.93103 9.93114V10.7587M10.7586 9.93114H11.5862M10.7586 9.93114V10.7587M11.5862 9.93114H12.4138M11.5862 9.93114V10.7587M12.4138 9.93114H13.2414M13.2414 9.93114H14.069M14.069 9.10355V9.93114M14.069 9.93114H14.8965M14.8965 9.93114H15.7241V10.7587H14.8965V9.93114ZM18.2069 9.10355H17.3793V9.93114M18.2069 9.10355V9.93114M18.2069 9.93114H17.3793M18.2069 9.93114H19.0345M18.2069 9.93114V10.7587M17.3793 9.93114V10.7587H18.2069M19.0345 9.93114V10.7587M3.31034 10.7587H2.48275M3.31034 10.7587V11.5863H2.48275V10.7587M7.44827 10.7587H6.62068M7.44827 10.7587H8.27586M6.62068 10.7587H5.7931M6.62068 10.7587V11.5863M8.27586 10.7587H9.10344M9.10344 10.7587H9.93103M9.93103 10.7587H10.7586M9.93103 10.7587V11.5863M11.5862 10.7587H10.7586M11.5862 10.7587V11.5863M10.7586 10.7587V11.5863M18.2069 10.7587H19.0345M18.2069 10.7587V11.5863M19.0345 10.7587V11.5863M19.0345 10.7587H19.8621M21.5172 10.7587H22.3448V9.93114H21.5172V10.7587ZM21.5172 10.7587H20.6896M21.5172 10.7587V11.5863M5.7931 10.7587H4.96551V11.5863M5.7931 10.7587V11.5863M5.7931 11.5863H4.96551M5.7931 11.5863H6.62068M5.7931 11.5863V12.4139H4.96551V11.5863M6.62068 11.5863H7.44827V12.4139M6.62068 11.5863V12.4139H7.44827M10.7586 11.5863H9.93103M10.7586 11.5863H11.5862M10.7586 11.5863V12.4139M9.93103 11.5863V12.4139H10.7586M11.5862 11.5863V12.4139M19.0345 11.5863H18.2069M19.0345 11.5863H19.8621M18.2069 11.5863H17.3793M18.2069 11.5863V12.4139M19.8621 10.7587V11.5863M19.8621 10.7587H20.6896M19.8621 11.5863H20.6896M20.6896 10.7587V11.5863M20.6896 11.5863H21.5172M20.6896 11.5863V12.4139M21.5172 11.5863V12.4139M21.5172 11.5863H22.3448V12.4139H21.5172M7.44827 12.4139H8.27586M7.44827 12.4139V13.2415M10.7586 12.4139H11.5862M10.7586 12.4139V13.2415M11.5862 12.4139V13.2415M16.5517 11.5863H15.7241V12.4139H16.5517M16.5517 11.5863V12.4139M16.5517 11.5863H17.3793M16.5517 12.4139H17.3793M16.5517 12.4139V13.2415M17.3793 11.5863V12.4139M17.3793 12.4139H18.2069M17.3793 12.4139V13.2415M18.2069 12.4139H19.0345V13.2415M18.2069 12.4139V13.2415M21.5172 12.4139H20.6896M21.5172 12.4139V13.2415M20.6896 12.4139V13.2415M2.48275 12.4139H1.65517V13.2415M2.48275 12.4139V13.2415M2.48275 12.4139H3.31034V13.2415M2.48275 13.2415H1.65517M2.48275 13.2415H3.31034M2.48275 13.2415V14.0691M1.65517 13.2415V14.0691M3.31034 13.2415V14.0691M3.31034 13.2415H4.13793V14.0691M8.27586 12.4139V13.2415M8.27586 12.4139H9.10344V13.2415M8.27586 13.2415H7.44827M8.27586 13.2415H9.10344M8.27586 13.2415V14.0691H7.44827M7.44827 13.2415H6.62068M7.44827 13.2415V14.0691M9.10344 13.2415H9.93103M9.10344 13.2415V14.0691M11.5862 13.2415H10.7586M11.5862 13.2415V14.0691M10.7586 13.2415H9.93103M10.7586 13.2415V14.0691M17.3793 13.2415H16.5517M17.3793 13.2415H18.2069M17.3793 13.2415V14.0691M16.5517 13.2415H15.7241V14.0691M16.5517 13.2415V14.0691H15.7241M19.0345 13.2415H18.2069M19.0345 13.2415V14.0691M18.2069 13.2415V14.0691M21.5172 13.2415H20.6896M21.5172 13.2415V14.0691M21.5172 13.2415H22.3448V14.0691M20.6896 13.2415V14.0691M2.48275 14.0691H1.65517M2.48275 14.0691H3.31034M2.48275 14.0691V14.8967M1.65517 14.0691V14.8967M3.31034 14.0691H4.13793M3.31034 14.0691V14.8967M4.13793 14.0691V14.8967M4.13793 14.0691H4.96551V14.8967M6.62068 13.2415H5.7931V14.0691M6.62068 13.2415V14.0691M6.62068 14.0691H5.7931M6.62068 14.0691H7.44827M6.62068 14.0691V14.8967M5.7931 14.0691V14.8967M9.93103 13.2415V14.0691M9.93103 14.0691H9.10344M9.93103 14.0691H10.7586M9.93103 14.0691V14.8967M9.10344 14.0691V14.8967M10.7586 14.0691H11.5862M10.7586 14.0691V14.8967M11.5862 14.0691V14.8967M14.069 13.2415H13.2414V14.0691M14.069 13.2415V14.0691M14.069 13.2415H14.8965V14.0691M14.069 14.0691H13.2414M14.069 14.0691H14.8965M14.069 14.0691V14.8967M13.2414 14.0691V14.8967M14.8965 14.0691H15.7241M14.8965 14.0691V14.8967M15.7241 14.0691V14.8967M18.2069 14.0691H17.3793M18.2069 14.0691H19.0345M18.2069 14.0691V14.8967M17.3793 14.0691V14.8967M19.0345 14.0691H19.8621M19.0345 14.0691V14.8967M21.5172 14.0691H20.6896M21.5172 14.0691H22.3448M21.5172 14.0691V14.8967M20.6896 14.0691H19.8621M20.6896 14.0691V14.8967M22.3448 14.0691V14.8967M2.48275 14.8967H1.65517M2.48275 14.8967V15.7242H1.65517V14.8967M4.13793 14.8967H3.31034M4.13793 14.8967H4.96551M4.13793 14.8967V15.7242M3.31034 14.8967V15.7242H4.13793M4.96551 14.8967V15.7242M4.96551 14.8967H5.7931M6.62068 14.8967H5.7931M6.62068 14.8967H7.44827M6.62068 14.8967V15.7242H7.44827M5.7931 14.8967V15.7242H4.96551M9.93103 14.8967H9.10344M9.93103 14.8967H10.7586M9.93103 14.8967V15.7242M9.10344 14.8967V15.7242M10.7586 14.8967H11.5862M10.7586 14.8967V15.7242M11.5862 14.8967V15.7242M14.069 14.8967H13.2414M14.069 14.8967V15.7242M14.069 14.8967H14.8965M13.2414 14.8967V15.7242H14.069M15.7241 14.8967H14.8965M15.7241 14.8967V15.7242M15.7241 14.8967H16.5517M14.8965 14.8967V15.7242M18.2069 14.8967H17.3793M18.2069 14.8967V15.7242M18.2069 14.8967H19.0345M17.3793 14.8967H16.5517M17.3793 14.8967V15.7242M19.8621 14.0691V14.8967M19.8621 14.8967H19.0345M19.8621 14.8967H20.6896M19.8621 14.8967V15.7242M19.0345 14.8967V15.7242M20.6896 14.8967V15.7242H19.8621M22.3448 14.8967H21.5172M22.3448 14.8967V15.7242H21.5172V14.8967M4.13793 15.7242H4.96551M7.44827 14.8967V15.7242M7.44827 14.8967H8.27586V15.7242M7.44827 15.7242H8.27586M8.27586 15.7242H9.10344M8.27586 15.7242V16.5518M9.93103 15.7242H9.10344M9.93103 15.7242V16.5518H9.10344M9.10344 15.7242V16.5518M11.5862 15.7242H10.7586M11.5862 15.7242V16.5518M11.5862 15.7242H12.4138V16.5518M10.7586 15.7242V16.5518M14.069 15.7242H14.8965M14.8965 15.7242H15.7241M14.8965 15.7242V16.5518M15.7241 15.7242H16.5517M15.7241 15.7242V16.5518M16.5517 14.8967V15.7242M16.5517 15.7242H17.3793M17.3793 15.7242H18.2069M18.2069 15.7242H19.0345M18.2069 15.7242V16.5518M19.0345 15.7242H19.8621M19.0345 15.7242V16.5518M9.10344 16.5518H8.27586M9.10344 16.5518V17.3794M8.27586 16.5518V17.3794H9.10344M11.5862 16.5518H10.7586M11.5862 16.5518H12.4138M11.5862 16.5518V17.3794M10.7586 16.5518V17.3794H11.5862M12.4138 16.5518H13.2414M12.4138 16.5518V17.3794M15.7241 16.5518H14.8965M15.7241 16.5518V17.3794M14.8965 16.5518H14.069M14.8965 16.5518V17.3794M19.0345 16.5518H18.2069M19.0345 16.5518V17.3794M19.0345 16.5518H19.8621M18.2069 16.5518V17.3794M2.48275 16.5518H1.65517V17.3794M2.48275 16.5518V17.3794M2.48275 16.5518H3.31034M2.48275 17.3794H1.65517M2.48275 17.3794H3.31034M2.48275 17.3794V18.207M1.65517 17.3794V18.207M3.31034 16.5518V17.3794M3.31034 16.5518H4.13793M3.31034 17.3794H4.13793M4.13793 16.5518V17.3794M4.13793 16.5518H4.96551M4.13793 17.3794H4.96551M4.96551 16.5518V17.3794M4.96551 16.5518H5.7931M4.96551 17.3794H5.7931M5.7931 16.5518V17.3794M5.7931 16.5518H6.62068M5.7931 17.3794H6.62068M6.62068 16.5518V17.3794M6.62068 16.5518H7.44827V17.3794M6.62068 17.3794H7.44827M6.62068 17.3794V18.207M7.44827 17.3794V18.207M9.10344 17.3794H9.93103V18.207H9.10344M9.10344 17.3794V18.207M11.5862 17.3794H12.4138M11.5862 17.3794V18.207H12.4138M13.2414 16.5518V17.3794M13.2414 16.5518H14.069M13.2414 17.3794H12.4138M13.2414 17.3794H14.069M13.2414 17.3794V18.207M12.4138 17.3794V18.207M14.069 16.5518V17.3794M14.069 17.3794H14.8965M14.069 17.3794V18.207M14.8965 17.3794H15.7241M14.8965 17.3794V18.207M15.7241 17.3794V18.207M19.0345 17.3794H18.2069M19.0345 17.3794H19.8621M19.0345 17.3794V18.207M18.2069 17.3794V18.207M19.8621 16.5518V17.3794M19.8621 16.5518H20.6896V17.3794H19.8621M19.8621 17.3794V18.207M2.48275 18.207H1.65517M2.48275 18.207V19.0346M1.65517 18.207V19.0346M7.44827 18.207H6.62068M7.44827 18.207V19.0346M6.62068 18.207V19.0346M9.10344 18.207H8.27586V19.0346M9.10344 18.207V19.0346M12.4138 18.207H13.2414M13.2414 18.207H14.069M13.2414 18.207V19.0346H14.069V18.207M14.8965 18.207H14.069M14.8965 18.207H15.7241M14.8965 18.207V19.0346H15.7241M15.7241 18.207V19.0346M15.7241 18.207H16.5517M19.0345 18.207H18.2069M19.0345 18.207H19.8621M19.0345 18.207V19.0346M18.2069 18.207H17.3793M18.2069 18.207V19.0346M19.8621 18.207V19.0346H19.0345M2.48275 19.0346H1.65517M2.48275 19.0346V19.8622M1.65517 19.0346V19.8622M4.13793 18.207H3.31034V19.0346M4.13793 18.207V19.0346M4.13793 18.207H4.96551M4.13793 19.0346H3.31034M4.13793 19.0346H4.96551M4.13793 19.0346V19.8622M3.31034 19.0346V19.8622M4.96551 18.207V19.0346M4.96551 18.207H5.7931V19.0346M4.96551 19.0346H5.7931M4.96551 19.0346V19.8622M5.7931 19.0346V19.8622M7.44827 19.0346H6.62068M7.44827 19.0346V19.8622M6.62068 19.0346V19.8622M9.10344 19.0346H8.27586M9.10344 19.0346V19.8622M9.10344 19.0346H9.93103M8.27586 19.0346V19.8622H9.10344M15.7241 19.0346H16.5517M15.7241 19.0346V19.8622M16.5517 18.207V19.0346M16.5517 18.207H17.3793M16.5517 19.0346H17.3793M16.5517 19.0346V19.8622M17.3793 18.207V19.0346M17.3793 19.0346H18.2069M18.2069 19.0346H19.0345M2.48275 19.8622H1.65517M2.48275 19.8622V20.6898M1.65517 19.8622V20.6898M4.13793 19.8622H3.31034M4.13793 19.8622H4.96551M4.13793 19.8622V20.6898M3.31034 19.8622V20.6898H4.13793M4.96551 19.8622H5.7931M4.96551 19.8622V20.6898M5.7931 19.8622V20.6898H4.96551M7.44827 19.8622H6.62068M7.44827 19.8622V20.6898M6.62068 19.8622V20.6898M9.10344 19.8622H9.93103M9.93103 19.0346V19.8622M9.93103 19.0346H10.7586V19.8622M9.93103 19.8622H10.7586M9.93103 19.8622V20.6898H10.7586V19.8622M16.5517 19.8622H15.7241M16.5517 19.8622V20.6898M16.5517 19.8622H17.3793V20.6898M15.7241 19.8622H14.8965V20.6898M15.7241 19.8622V20.6898M22.3448 19.8622V19.0346H21.5172V19.8622M22.3448 19.8622H21.5172M22.3448 19.8622V20.6898M21.5172 19.8622H20.6896V20.6898M21.5172 19.8622V20.6898M2.48275 20.6898H1.65517M2.48275 20.6898V21.5173M1.65517 20.6898V21.5173M4.13793 20.6898H4.96551M7.44827 20.6898H6.62068M7.44827 20.6898V21.5173M6.62068 20.6898V21.5173M14.069 20.6898V19.8622H13.2414V20.6898M14.069 20.6898H13.2414M14.069 20.6898V21.5173M14.069 20.6898H14.8965M13.2414 20.6898V21.5173M15.7241 20.6898H14.8965M15.7241 20.6898H16.5517M15.7241 20.6898V21.5173M14.8965 20.6898V21.5173M16.5517 20.6898H17.3793M16.5517 20.6898V21.5173M17.3793 20.6898V21.5173M17.3793 20.6898H18.2069M19.0345 20.6898V19.8622H18.2069V20.6898M19.0345 20.6898H18.2069M19.0345 20.6898H19.8621M19.0345 20.6898V21.5173M18.2069 20.6898V21.5173M21.5172 20.6898H20.6896M21.5172 20.6898H22.3448M21.5172 20.6898V21.5173M20.6896 20.6898H19.8621M20.6896 20.6898V21.5173M22.3448 20.6898V21.5173M2.48275 21.5173H1.65517M2.48275 21.5173V22.3449M2.48275 21.5173H3.31034M1.65517 21.5173V22.3449H2.48275M7.44827 21.5173H6.62068M7.44827 21.5173V22.3449H6.62068M6.62068 21.5173H5.7931M6.62068 21.5173V22.3449M14.069 21.5173H13.2414M14.069 21.5173H14.8965M14.069 21.5173V22.3449M13.2414 21.5173H12.4138V22.3449H13.2414M13.2414 21.5173V22.3449M14.8965 21.5173H15.7241M14.8965 21.5173V22.3449M15.7241 21.5173H16.5517M15.7241 21.5173V22.3449H14.8965M16.5517 21.5173H17.3793M16.5517 21.5173V22.3449H17.3793V21.5173M17.3793 21.5173H18.2069M18.2069 21.5173H19.0345M18.2069 21.5173V22.3449H19.0345M19.8621 20.6898V21.5173M19.8621 21.5173H19.0345M19.8621 21.5173H20.6896M19.8621 21.5173V22.3449H19.0345M19.0345 21.5173V22.3449M20.6896 21.5173H21.5172M21.5172 21.5173H22.3448M21.5172 21.5173V22.3449H22.3448V21.5173M2.48275 22.3449H3.31034M3.31034 21.5173V22.3449M3.31034 21.5173H4.13793M3.31034 22.3449H4.13793M4.13793 21.5173V22.3449M4.13793 21.5173H4.96551M4.13793 22.3449H4.96551M4.96551 21.5173V22.3449M4.96551 21.5173H5.7931M4.96551 22.3449H5.7931M5.7931 21.5173V22.3449M5.7931 22.3449H6.62068M13.2414 22.3449H14.069M14.069 22.3449H14.8965M14.8965 1.65527H15.7241V2.48286H14.8965V1.65527ZM14.069 11.5863H14.8965V12.4139H14.069V11.5863ZM16.5517 16.5518H17.3793V17.3794H16.5517V16.5518ZM21.5172 16.5518H22.3448V17.3794H21.5172V16.5518ZM11.5862 19.8622H12.4138V20.6898H11.5862V19.8622ZM9.10344 21.5173H9.93103V22.3449H9.10344V21.5173Z",
    stroke: "black",
    strokeWidth: 0.048
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0672 22.4981V23.6396H28.2775V23.159H28.3075C28.3075 23.189 28.6079 23.6396 28.6079 23.6396H28.8482C28.8482 23.6396 28.5478 23.189 28.5178 23.1289C28.668 23.0989 28.7581 22.9787 28.7581 22.8286C28.7581 22.6784 28.668 22.4981 28.3977 22.4981H28.0672ZM28.3376 22.6784C28.5178 22.6784 28.5478 22.7685 28.5478 22.8286C28.5478 22.9487 28.5178 23.0088 28.2775 23.0088H28.2475V22.6784H28.3376ZM29.1486 23.0689C29.1486 23.4894 28.8182 23.8198 28.3977 23.8198C27.9771 23.8198 27.6467 23.4894 27.6467 23.0689C27.6467 22.6483 27.9771 22.3179 28.3977 22.3179C28.8182 22.3179 29.1486 22.6483 29.1486 23.0689ZM28.3977 22.1377C27.887 22.1377 27.4665 22.5582 27.4665 23.0689C27.4665 23.5795 27.887 24 28.3977 24C28.9083 24 29.3288 23.5795 29.3288 23.0689C29.2988 22.5582 28.9083 22.1377 28.3977 22.1377Z",
    fill: "#FEBE10"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.6394C21.3993 23.3691 16.3529 21.1764 14.7309 19.8547C12.9887 18.4129 12.0576 16.3704 12.0576 13.9073V2.19273C14.821 0.720898 18.1552 0 22 0C25.8448 0 29.179 0.750935 31.9424 2.19273V13.9073C31.9424 16.3704 31.0113 18.443 29.2691 19.8547C27.6771 21.1463 22.6008 23.3691 22 23.6394Z",
    fill: "#FEBE10"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9889 13.8768C12.9889 16.0695 13.7999 17.8718 15.3319 19.1333C16.6836 20.2447 20.8287 22.107 22.0002 22.6477C23.1717 22.1371 27.3168 20.2748 28.6685 19.1333C30.2004 17.8718 31.0115 16.0996 31.0115 13.8768V2.43255C25.2442 1.89187 18.3957 2.22228 12.9889 7.20849V13.8768ZM13.8901 13.1859V7.74916H15.6022V13.276C15.6022 13.7566 15.7224 14.5076 16.5033 14.5076C16.8638 14.5076 17.1341 14.4175 17.3143 14.2973V7.74916H19.0265V15.2585C18.3657 15.7091 17.4946 15.9494 16.4132 15.9494C14.7311 15.9494 13.8901 15.0182 13.8901 13.1859ZM21.6698 19.4637H19.9276V8.19973C20.5584 7.80924 21.3093 7.59898 22.2705 7.59898C24.3431 7.59898 25.4545 9.16092 25.4545 11.6841C25.4545 14.2072 24.3431 15.9494 22.4508 15.9494C22.0903 15.9494 21.85 15.8893 21.6698 15.8593V19.4637ZM21.6698 9.10085C21.82 9.04077 22.0603 8.9807 22.2705 8.9807C23.2618 8.9807 23.6823 9.79171 23.6823 11.7141C23.6823 13.6065 23.2017 14.5076 22.2105 14.5076C21.9702 14.5076 21.7599 14.4475 21.6397 14.4175V9.10085H21.6698ZM25.845 9.82174C25.845 8.40999 27.0165 7.59898 28.1579 7.56894C29.1191 7.5389 29.7499 7.89935 30.0503 8.13965V9.64152C29.6898 9.28107 29.1191 8.95066 28.4883 8.92062C28.0077 8.92062 27.4971 9.13088 27.467 9.76167C27.437 10.3925 27.9476 10.6328 28.6085 11.0232C30.0503 11.8643 30.3206 12.6453 30.2906 13.6365C30.2605 14.7479 29.5096 15.9494 27.7974 15.9494C27.1066 15.9494 26.4458 15.7391 25.9051 15.4087V13.8167C26.3556 14.2072 27.0165 14.5076 27.5571 14.5076C28.1879 14.5076 28.6085 14.1471 28.5784 13.5464C28.5784 13.0057 28.248 12.7053 27.4971 12.2548C26.1153 11.4438 25.875 10.7529 25.845 9.82174Z",
    fill: "#371400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeUpsIcon);
export default __webpack_public_path__ + "static/media/qr-code-ups-icon.6aeb245e7f93a910495798d9afdd202b.svg";
export { ForwardRef as ReactComponent };